import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { BASE_URL } from './BaseUrl';
import InnerHeader from './InnerHeader';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';



const ChequeNumber = () => {

    const [vendordata, setVendorData] = useState([])
    const [error, setError] = useState({})
    const [value, setValue] = useState({
        Cheque_No: '',
    })



    //==============Validation

    const validateForm = () => {
        let isValid = true
        const newErrors = {}


        if (!value.Cheque_No) {
            isValid = false;
            newErrors.Cheque_No = "Cheque Number is Required"
        }
        setError(newErrors)
        return isValid
    }


    const handleSubmit = (e) => {
        e.preventDefault();

        if (validateForm()) {
            const data = { Cheque_No: value.Cheque_No };

            axios.post(`${BASE_URL}/getservicetaxcheque`, data)
                .then((res) => {
                    console.log(res.data);
                    setVendorData(res.data);

                    // Calculate total amount
                    const totalAmount = res.data.reduce((sum, item) => sum + parseFloat(item.Amount || 0), 0);

                    // Set to receivedamount field
                    setValue((prev) => ({ ...prev, receivedamount: totalAmount.toFixed(2) }));
                })
                .catch((err) => {
                    console.log(err);
                });
        }
    };


    const onhandleChange = (e) => {
        setValue((prev) => ({ ...prev, [e.target.name]: e.target.value }))
    }

    const columns = [
        {
            field: 'index',
            headerName: 'Id',
            type: 'number',
            align: 'center',
            headerAlign: 'center',
            flex: 1,
            filterable: false,

        },
        { field: 'Fees_Code', headerName: 'Receipt No.', flex: 2 },
        { field: 'Student_Name', headerName: 'Student Name', flex: 2 },
        {
    field: 'RDate',
    headerName: 'Receipt Date',
    flex: 2,
    renderCell: (params) => {
        if (!params.value) return "";

        // If already in DD-MM-YYYY format
        const ddmmyyyyRegex = /^\d{2}-\d{2}-\d{4}$/;
        if (ddmmyyyyRegex.test(params.value)) {
            return params.value;
        }

        // If API returns yyyymmdd format
        if (/^\d{8}$/.test(params.value)) {
            const year = params.value.substring(0, 4);
            const month = params.value.substring(4, 6);
            const day = params.value.substring(6, 8);
            return `${day}-${month}-${year}`;
        }

        // Try parsing yyyy-mm-dd or Date object
        const date = new Date(params.value);
        if (isNaN(date.getTime())) return "";

        return `${String(date.getDate()).padStart(2, "0")}-${String(date.getMonth() + 1).padStart(2, "0")}-${date.getFullYear()}`;
    }
},

        { field: 'Payment_Type', headerName: 'Payment Type', flex: 2 },
        { field: 'Amount', headerName: 'Amount', flex: 2 },
        { field: 'Cheque_No', headerName: 'Cheque No', flex: 2 },
       {
    field: 'Cheque_Date',
    headerName: 'Cheque Date',
    flex: 2,
    renderCell: (params) => {
        if (!params.value) return "";

        // If already in DD-MM-YYYY format
        const ddmmyyyyRegex = /^\d{2}-\d{2}-\d{4}$/;
        if (ddmmyyyyRegex.test(params.value)) {
            return params.value;
        }

        // If API returns yyyymmdd format
        if (/^\d{8}$/.test(params.value)) {
            const year = params.value.substring(0, 4);
            const month = params.value.substring(4, 6);
            const day = params.value.substring(6, 8);
            return `${day}-${month}-${year}`;
        }

        // Try parsing yyyy-mm-dd or Date object
        const date = new Date(params.value);
        if (isNaN(date.getTime())) return "";

        return `${String(date.getDate()).padStart(2, "0")}-${String(date.getMonth() + 1).padStart(2, "0")}-${date.getFullYear()}`;
    }
}


    ];

    const exportToExcel = () => {
        const worksheetData = [
            // Header Row (merged)
            [{
                v: `Service Tax Report for Cheque Number: ${value.Cheque_No}`,
                s: { font: { bold: true, sz: 14 }, alignment: { horizontal: "center" } }
            }],

            [], // Empty row
            // Table Headers
            [
                { v: 'Receipt No.', s: { font: { bold: true }, fill: { fgColor: { rgb: "D9D9D9" } } } },
                { v: 'Student Name', s: { font: { bold: true }, fill: { fgColor: { rgb: "D9D9D9" } } } },
                { v: 'Receipt Date', s: { font: { bold: true }, fill: { fgColor: { rgb: "D9D9D9" } } } },
                { v: 'Payment Type', s: { font: { bold: true }, fill: { fgColor: { rgb: "D9D9D9" } } } },
                { v: 'Ammount', s: { font: { bold: true }, fill: { fgColor: { rgb: "D9D9D9" } } } },
                { v: 'Cheque No.', s: { font: { bold: true }, fill: { fgColor: { rgb: "D9D9D9" } } } },
                { v: 'Cheque Date', s: { font: { bold: true }, fill: { fgColor: { rgb: "D9D9D9" } } } },
            ],
        ];

        // Adding Data Rows
        vendordata.forEach(item => {
            worksheetData.push([
                item.Fees_Code,
                item.Student_Name,
                item.RDate,
                item.Payment_Type,
                parseFloat(item.Amount).toFixed(2),
                item.Cheque_No,
                item.Cheque_Date,
            ]);
        });

        // Create worksheet and workbook
        const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);

        // Merge the first header row across A1:G1
        worksheet['!merges'] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: 6 } }];

        // Column widths
        worksheet['!cols'] = [
            { wch: 15 },
            { wch: 25 },
            { wch: 18 },
            { wch: 18 },
            { wch: 15 },
            { wch: 25 },
            { wch: 18 },
        ];

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Report");

        // Export to file
        const wbout = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        saveAs(new Blob([wbout], { type: 'application/octet-stream' }), 'ServiceTaxReport.xlsx');
    };



    const rowsWithIds = vendordata.map((row, index) => ({ index: index + 1, ...row }));


    return (
        <div className="container-fluid page-body-wrapper ">
            <InnerHeader />
            <div className="main-panel">

                <div className="content-wrapper">
                    <div className="row">
                        <div className="col-lg-12 grid-margin">
                            <div class="d-flex">

                                <div className='px-2 mx-2'><Link to="/servicetaxreportonfees"><h4>Month & Year Wise</h4></Link></div>
                                <div className='px-2 mx-2'><Link to="/chequenumber"><h4>Cheque Number</h4></Link></div>
                            </div>
                            <div className="card">
                                <div className='container-fluid'>
                                    <div className='row d-flex justify-content-between'>

                                        <div className='col-lg-12'>
                                            <div className='row justify-content-center' >
                                                <div className='p-3' style={{ width: "100%" }}>
                                                    <form class="form-sample py-3" onSubmit={handleSubmit}>
                                                        <div class="row">

                                                            <div class="form-group col-lg-3">
                                                                <label for="exampleInputUsername1">Cheque Number<span className="text-danger">*</span></label>
                                                                <input type="text" class="form-control" id="exampleInputUsername1"
                                                                    value={value.Cheque_No} placeholder="Cheque Number"
                                                                    name='Cheque_No' onChange={onhandleChange} />

                                                                {<span className='text-danger'>{error.Cheque_No}</span>}
                                                            </div>

                                                        </div>

                                                        <div className='row p-2 gap-2'>
                                                            <button type='submit' class="btn btn-primary mr-2">Go</button>
                                                        </div>


                                                    </form>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-12">
                                            <div class="card">
                                                <div class="card-body">
                                                    <div className='d-flex justify-content-between'>
                                                        <div>
                                                            <h4 class="card-title">Details</h4>
                                                        </div>

                                                    </div>

                                                    {<div>

                                                        <DataGrid
                                                            rows={rowsWithIds}
                                                            columns={columns}
                                                            disableColumnFilter
                                                            disableColumnSelector
                                                            disableDensitySelector
                                                            rowHeight={35}
                                                            getRowId={(row) => row.index} // <-- Important Fix
                                                            initialState={{
                                                                pagination: {
                                                                    paginationModel: { pageSize: 10, page: 0 },
                                                                },
                                                            }}
                                                        />


                                                    </div>}

                                                    <div class="card-title text-center">
                                                        <h4>Total Record:</h4>
                                                        <div class="d-flex justify-content-center">

                                                            <div class="form-group">
                                                                <label for="exampleInputUsername1">Total Received Amount  </label>
                                                                <input
                                                                    style={{ width: "300px" }}
                                                                    type="text"
                                                                    class="form-control"
                                                                    id="exampleInputUsername1"
                                                                    value={value.receivedamount}
                                                                    placeholder="Total Received Amount"
                                                                    name='receivedamount'
                                                                    onChange={onhandleChange}
                                                                    disabled
                                                                />

                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="justify-content-center">
                                                        <button type="submit" class="btn btn-primary mr-2" onClick={exportToExcel}>Print</button>

                                                        <button type='button' onClick={() => {
                                                            window.location.reload()
                                                        }} class="btn btn-light">Close</button>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default ChequeNumber